import { useMemo } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { Empty, ImageViewer } from "antd-mobile";
import useNavigation from "../../hooks/useNavigation";
import PageWrap from "../components/PageWrap";
import PageHeader, { headerHeight } from "../components/PageHeader";
import useGlobalTheme from "../../hooks/useGlobalTheme";
import { staticUrl } from "../../utils";

const ScrollArea = styled.div`
  height: calc(100% - ${headerHeight});
  overflow: auto;
  background: #f7f8ff;
`;

const Col = styled.div`
  padding: 10px 15px;
  margin-bottom: 5px;
  background: #fff;
`;

const Label = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.secondaryText || "#999"};
  padding: 5px 0;
`;

const Value = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
  line-height: 20px;
  word-break: break-all;
`;

const StatusText = styled.div<{ $color: string }>`
  font-size: 14px;
  color: ${({ $color }) => $color};
`;

const ImgRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -5px;
`;

const ImgBox = styled.img`
  width: 60px;
  height: 60px;
  margin: 5px;
  border-radius: 6px;
  object-fit: cover;
  cursor: pointer;
  background: #f2f2f2;
`;

const MyComplaintDetail = () => {
  const theme = useGlobalTheme();
  const { params } = useNavigation();
  const order = params.order as any;

  const statusColor = useMemo(
    () => (order?.status === 11 ? "#ED860E" : theme.colors.text),
    [order?.status, theme.colors.text]
  );

  const imgs: any[] = order?.options?.dispute_imgs || [];

  const onPreview = (index: number) => {
    ImageViewer.Multi.show({
      images: imgs.map((item) => staticUrl(item.url)),
      defaultIndex: index,
    });
  };

  if (!order) {
    return (
      <PageWrap>
        <PageHeader title="申诉详情" />
        <ScrollArea>
          <Empty description="申诉信息不存在" style={{ padding: 40 }} />
        </ScrollArea>
      </PageWrap>
    );
  }

  const resultText =
    order.status === 10
      ? "待处理，请耐心等待"
      : order.status === 12
      ? "已发货"
      : "已取消";

  return (
    <PageWrap>
      <PageHeader title="申诉详情" />
      <ScrollArea>
        <Col>
          <Label>订单号</Label>
          <Value>{order.trans_no}</Value>
        </Col>
        <Col>
          <Label>申诉原因</Label>
          <Value>{order.options?.dispute_reason || ""}</Value>
        </Col>
        <Col>
          <Label>补充截图</Label>
          <ImgRow>
            {imgs.map((item, index) => (
              <ImgBox
                key={`${item.url}-${index}`}
                src={staticUrl(item.url)}
                alt=""
                onClick={() => onPreview(index)}
              />
            ))}
          </ImgRow>
        </Col>
        <Col>
          <Label>处理结果</Label>
          <StatusText $color={statusColor}>{resultText}</StatusText>
        </Col>
      </ScrollArea>
    </PageWrap>
  );
};

export default observer(MyComplaintDetail);
